import { GenericVehicleDetails } from '@finn/ua-vehicle';

const nextWeek = new Date().setDate(new Date().getDate() + 14);
const nextWeekString = new Date(nextWeek).toISOString();

export const SMALL_FAKE_PRODUCT = {
  availability: 54,
  available_from_deviation_in_weeks: 0,
  available_from: nextWeekString,
  available_states: null,
  available_terms: [36],
  available_to: '2025-08-14',
  related_configs: [],
  color_list: [
    {
      availability: 54,
      availability_date: '2025-07-15',
      brand: 'Opel',
      car_id: 'category-small',
      color_hex: '#000000',
      color_specific: 'Schwarz, Weiß oder Silber',
      desktop_sorting: 1906881,
      id: 'Schwarz',
      model: 'Corsa',
      picture_front_url:
        'https://res.cloudinary.com/finn-auto/image/upload/v1747830479/category-small.jpg',
      pricing: [344],
      sorting: '2025-07-15-22432',
      uid: 22432,
    },
  ],
  downpayment_prices: {
    available_price_list: {
      b2b_12: 189,
      b2c_12: 229,
      b2b_24: 164,
      b2c_24: 199,
    },
    msrp: 24880,
    extra_km_price: 0.25,
    extra_500: 0,
    extra_1000: 9,
    extra_1500: 59,
    extra_2000: 109,
    extra_2500: 159,
    extra_3000: 199,
    extra_4000: 299,
    extra_5000: 389,
    downpayment_fixed_amount: 1500,
    downpayment_discount_percentage: 3,
  },
  price: {
    available_price_list: {
      b2b_12: 293,
      b2c_12: 354,
      b2b_24: 164,
      b2c_24: 199,
    },
    msrp: 24880,
    extra_km_price: 0.25,
    extra_500: 0,
    extra_1000: 9,
    extra_1500: 59,
    extra_2000: 109,
    extra_2500: 159,
    extra_3000: 199,
    extra_4000: 299,
    extra_5000: 389,
  },
  default_term: 24,
  default_downpayment_term: 24,
  availability_by_term: {
    '12': {
      available_from: nextWeekString,
      available_to: '2025-08-14T00:00:00.000Z',
      deviation_in_weeks: 0,
    },
    '24': {
      available_from: nextWeekString,
      available_to: '2025-08-14T00:00:00.000Z',
      deviation_in_weeks: 0,
    },
  },
  brand: {
    id: 'Opel',
    picture: {
      filename: 'opel.svg',
      size: 982,
      url: 'https://dataops-nocodb-s3-bucket-production.s3.eu-central-1.amazonaws.com/nc/uploads/noco/ua_main_restapi_de/brands/logo/ywXYF8.svg',
      type: 'image/svg+xml',
    },
    helper_brand_logo: {
      filename: 'opel.svg',
      size: 982,
      url: 'https://dataops-nocodb-s3-bucket-production.s3.eu-central-1.amazonaws.com/nc/uploads/noco/ua_main_restapi_de/brands/logo/ywXYF8.svg',
      type: 'image/svg+xml',
    },
  },
  cartype: 'Kleinwagen',
  co2emission: 120,
  co2_class: 'D',
  color: {
    color_hex: '#000000',
    id: 'Schwarz',
    specific: 'Schwarz, Weiß oder Silber',
  },
  config: {
    link: 'https://dataops-nocodb-s3-bucket-production.s3.eu-central-1.amazonaws.com/nc/uploads/noco/fleet_blue_dragon/configs/attachment/L0G-gC.pdf',
    name: 'attachment.pdf',
  },
  config_drive: 'Frontantrieb',
  config_hitch: null,
  config_id: 22432,
  consumption: 5.3,
  consumption_city: null,
  consumption_highway: null,
  delivery_options: 'delivery',
  depreciation: null,
  description: 'MG MG3 oder Hyundai i20',
  doors: '5',
  efficiency_class: null,
  efficiency_image: null,
  energy_class_file: null,
  engine: 'Oder ähnlich',
  equipment: {
    multimedia:
      'Audio-Anlage Digitalradio٫ Touch Screen und 80, Media-Anschlüsse USB vorne٫ Anzahl USB vorne: 1٫ Anzahl USB hinten: 0 und Anzahl USB 3. Reihe: 0',
    safety:
      'ABS, Isofix, Crash Warnsystem aktiviert Bremslicht٫ automatische Notbremsung٫ Bremst bei niedriger Geschwindigkeit Mindestgeschw. Zur Aktivierung: 5 km/h Fußgängerschutz٫ visuelle/akustische Warnung٫ Funktion über 130 km/h 78 mph٫ Funktion über 50 km/h 30 mph٫ Funktion unter 50 km/h 30 mph und Überwachung Fahrstil',
    comfort: 'Geschwindigkeitsregelanlage, Frontantrieb, Bluetooth',
  },
  equipment_delimiter: ', ',
  equipment_line: 'Oder ähnlich',
  equipment_packages: null,
  ev_range: null,
  financing_type: 'abs_2',
  fuel: 'Benzin oder Diesel',
  gearshift: 'Automatik oder Manuell',
  gross_capitalized_cost: null,
  has_hitch: 'false',
  has_real_pictures: false,
  id: 'category-small',
  indexable: true,
  model: 'Corsa',
  model_year: '2025',
  offer_type: 'subscription',
  picture: {
    url: 'https://res.cloudinary.com/finn-auto/image/upload/v1747916320/zrxqvyriqwlkjkm9fwlt.png',
  },
  pictures: [
    {
      url: 'https://res.cloudinary.com/finn-auto/image/upload/v1747916320/zrxqvyriqwlkjkm9fwlt.png',
    },
    {
      url: 'https://dataops-nocodb-s3-bucket-production.s3.eu-central-1.amazonaws.com/nc/uploads/noco/fleet_blue_dragon/car_images/image/54RPnA.png',
    },
    {
      url: 'https://dataops-nocodb-s3-bucket-production.s3.eu-central-1.amazonaws.com/nc/uploads/noco/fleet_blue_dragon/car_images/image/RuvZAx.png',
    },
    {
      url: 'https://dataops-nocodb-s3-bucket-production.s3.eu-central-1.amazonaws.com/nc/uploads/noco/fleet_blue_dragon/car_images/image/_ovv5o.png',
    },
    {
      url: 'https://dataops-nocodb-s3-bucket-production.s3.eu-central-1.amazonaws.com/nc/uploads/noco/fleet_blue_dragon/car_images/image/P4kdoS.png',
    },
    {
      url: 'https://dataops-nocodb-s3-bucket-production.s3.eu-central-1.amazonaws.com/nc/uploads/noco/fleet_blue_dragon/car_images/image/8fziPL.png',
    },
    {
      url: 'https://dataops-nocodb-s3-bucket-production.s3.eu-central-1.amazonaws.com/nc/uploads/noco/fleet_blue_dragon/car_images/image/-ia4xh.png',
    },
    {
      url: 'https://dataops-nocodb-s3-bucket-production.s3.eu-central-1.amazonaws.com/nc/uploads/noco/fleet_blue_dragon/car_images/image/Bm52BW.png',
    },
  ],
  power: 74,
  product_desktop_sorting: 1906881,
  product_group: [],
  product_label: {
    label: null,
    label_color: null,
    label_inverted: null,
    label_text_color: null,
  },
  product_path: null,
  product_stock_preorder: null,
  product_stock_total: 54,
  product_stock_webflow: 54,
  purchasing_deal_name: null,
  recurrent_payment_method_list: ['stripe_credit_card', 'stripe_debit_sepa'],
  residual_values: null,
  seats: '5',
  seo_canonical_product_id: null,
  single_payment_method_list: ['stripe_credit_card', 'stripe_debit_sepa'],
  source: 'blue_dragon',
  fake_door_filters: 'mg.opel.hyundai_mg3_corsa_i20',
  states_stock: null,
  tires: 'all_season',
  trim_name: 'Oder ähnlich',
  uid: 22432,
} as unknown as GenericVehicleDetails;
